<template>
<div class="site container hfeed">
  <HeadNav selectedLanguage="en" page="troubleshooting" />
  <article class="seo-topic-page">
    <SeoBreadcrumb :items="breadcrumbItems" />
    <section class="blog-content troubleshooting-hub">
      <header class="troubleshooting-hub__intro">
        <h1>All GB WhatsApp Troubleshooting Guides</h1>
        <p class="troubleshooting-hub__lead">
          Having trouble with GB WhatsApp? Browse our complete collection of troubleshooting guides to fix installation issues, update errors, verification problems, notification failures, chat restore issues, and other common APK-related questions.
        </p>
      </header>

      <div class="troubleshooting-hub__grid">
        <section v-for="block in sections" :key="block.title" class="troubleshooting-hub__card">
          <h2 class="troubleshooting-hub__heading">{{ block.title }}</h2>
          <ul class="troubleshooting-hub__list">
            <li
              v-for="(item, index) in block.items"
              :key="index"
              :class="{ 'is-link': item.to }"
            >
              <router-link v-if="item.to" :to="item.to">{{ item.label }}</router-link>
              <span v-else>{{ item.label }}</span>
            </li>
          </ul>
        </section>
      </div>
    </section>
  </article>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import '@/css/seo-guide-page.scss';
import '@/css/gb-wave-home.scss';
import HeadNav from '@/components/HeadNav.vue';
import SeoBreadcrumb from '@/components/SeoBreadcrumb.vue';

export default {
  name: 'TroubleshootingHub',
  components: { HeadNav, SeoBreadcrumb },
  data() {
    return {
      breadcrumbItems: [
        { label: 'Home', to: { name: 'en-gb' } },
        { label: 'Troubleshooting', current: true },
      ],
      sections: [
        {
          title: 'Installation Issues',
          items: [
            { label: 'GB WhatsApp Not Installing: Causes and Fixes', to: '/gb-whatsapp-not-installing/' },
            { label: 'Parse Error' },
            { label: 'App Not Compatible' },
            { label: 'App Not Installed' },
          ],
        },
        {
          title: 'Verification Problems',
          items: [
            { label: 'GB WhatsApp Verification Failed? Try These Solutions', to: '/gb-whatsapp-verification-failed/' },
            { label: 'Why Is GB WhatsApp Not Sending the SMS Code?', to: '/gb-whatsapp-sms-code-not-received/' },
            { label: 'Phone Number Verification Error' },
          ],
        },
        {
          title: 'Update Issues',
          items: [
            { label: 'GB WhatsApp Update Failed: Causes and Fixes', to: '/gb-whatsapp-update-failed/' },
            { label: 'How to Update GB WhatsApp' },
            { label: 'Lost Chats After Update' },
          ],
        },
        {
          title: 'Chat Backup & Restore',
          items: [
            { label: 'GB WhatsApp Chat Backup Not Working? Easy Fixes', to: '/gb-whatsapp-chat-backup-not-working/' },
            { label: 'GB WhatsApp Chats Not Restoring After Reinstall? Easy Fixes', to: '/gb-whatsapp-chats-not-restoring/' },
            { label: 'Transfer to New Phone' },
          ],
        },
        {
          title: 'Notifications & Performance',
          items: [
            { label: 'GB WhatsApp Notifications Not Working? Easy Fixes', to: '/gb-whatsapp-notifications-not-working/' },
            { label: 'Why Does GB WhatsApp Keep Crashing on Android?', to: '/gb-whatsapp-keeps-crashing/' },
            { label: 'Battery Optimization Issues' },
          ],
        },
        {
          title: 'Privacy & Security',
          items: [
            { label: 'Is GB WhatsApp Safe? Security and Privacy Risks', to: '/is-gb-whatsapp-safe/' },
            { label: 'How Can You Avoid GB WhatsApp Account Restrictions?', to: '/avoid-gb-whatsapp-account-restrictions/' },
            { label: 'Privacy Settings Guide' },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.troubleshooting-hub__intro {
  margin-bottom: 0.5rem;
}

.troubleshooting-hub__lead {
  margin: 0;
  max-width: none;
  width: 100%;
  font-size: 1rem;
  line-height: 1.65;
  color: #5a6472;
}

.troubleshooting-hub__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 1.75rem;
}

.troubleshooting-hub__card {
  padding: 18px 18px 16px;
  border: 1px solid #e6ebe8;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(18, 76, 43, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.troubleshooting-hub__card:hover {
  border-color: #d4e8dc;
  box-shadow: 0 10px 24px rgba(18, 76, 43, 0.07);
}

.troubleshooting-hub__heading {
  margin: 0 0 12px;
  padding: 0 0 0 11px;
  border-left: 3px solid var(--gb-wave-green, #28a745);
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.35;
  color: #1a1f27;
  letter-spacing: -0.01em;
}

.troubleshooting-hub__list {
  margin: 0 !important;
  padding: 0 !important;
  list-style: none !important;
}

.troubleshooting-hub__list > li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #3d4654;
  list-style: none !important;
}

.troubleshooting-hub__list > li::before {
  content: '';
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  margin-top: 0.55em;
  border-radius: 50%;
  background: rgba(40, 167, 69, 0.45);
}

.troubleshooting-hub__list > li + li {
  margin-top: 6px;
}

/* 可跳转：主题色链接，无背景框 */
.troubleshooting-hub__list > li.is-link {
  font-size: 0.94rem;
}

.troubleshooting-hub__list > li.is-link::before {
  background: var(--gb-wave-green, #28a745);
}

.troubleshooting-hub__list > li.is-link a {
  flex: 1;
  min-width: 0;
  color: #0b7a3a;
  font-weight: 600;
  text-decoration: none;
  text-underline-offset: 3px;
  transition: color 0.18s ease;
}

.troubleshooting-hub__list > li.is-link a:hover,
.troubleshooting-hub__list > li.is-link a:focus-visible {
  color: #1e7e34;
  text-decoration: underline;
}

/* 暂无链接：与第一条文字左缘对齐 */
.troubleshooting-hub__list > li:not(.is-link) {
  font-size: 0.875rem;
  color: #1a1f27;
}

.troubleshooting-hub__list > li:not(.is-link) > span {
  flex: 1;
  min-width: 0;
}

@media (max-width: 720px) {
  .troubleshooting-hub__grid {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-top: 1.35rem;
  }

  .troubleshooting-hub__lead {
    font-size: 0.95rem;
  }

  .troubleshooting-hub__heading {
    font-size: 1rem;
  }
}
</style>
